import { useTypedSelector } from 'common/hooks/useTypedSelector';
import PrimaryButton from 'components/form/buttons/primaryButton';
import TeaboyReasonsTable from './lib/table';

import PageTitle from 'components/pageTitle';

import * as S from './styles';

const PlusIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round">
    <path d="M12 5v14M5 12h14" />
  </svg>
);

export default function TeaboyCancelledReasons() {
  const { rejectReasons }: any = useTypedSelector((state) => state.Cafeteria);

  return (
    <S.Container>
      <PageTitle title="Teaboy Cancelled Reasons" />
      <S.Head>
        <PrimaryButton link="/panel/cafeteria/teaboy-cancelled-reason/create">
          <PlusIcon />
          New reason
        </PrimaryButton>
      </S.Head>
      <TeaboyReasonsTable menuList={rejectReasons.data} loading={rejectReasons.loading} />
    </S.Container>
  );
}
